import React, { useEffect, useState } from 'react';
import Button from '../../Buttons/Button/Button';
import styled from 'styled-components';
import Simple from '../../Response/Templates/Simple';
import { Happy } from '../../Ratings/RatingIcons';

interface Props {
	data: any;
	shouldDisableActions?: boolean;
	handleSubmit?: Function;
	isInsideCampaign: boolean;
	botImageCheck: boolean;
	index: number;
	logoImagePath?: string;
	voiceResponse?: boolean;
	langCode?: string;
	lengthArray: number;
	addUserResponse: Function;
	addServerMessage: Function;
	getCartId: Function;
	makePayment: Function;
}

const ShopifyCart = styled.div`
	.ff-shopify-view-cart-header {
		border-bottom: 1px solid
			${(props: any) => {
				return props.foreground + '33'; // 0.2
			}};
	}
	.caption-text {
		color: ${(props: any) => {
			return props.foreground + '99'; // 0.6
		}};
	}
`;

const styleVars = getComputedStyle(document.querySelector(':root'));
export const ViewCart = (props: Props) => {
	useEffect(() => {
		props.getCartId(JSON.parse(props.data.displayResponse).data.data.cart.id);
	}, []);
	let foreground = styleVars.getPropertyValue('--srvMsgColor') || '#ffffff';
	let background =
		styleVars.getPropertyValue('--srvMsgBackgorund') || '#383ff6';

	let cartButtons = ['Modify', 'Remove'];
	let postCartButtons = ['Checkout', 'Continue Shopping'];
	let response = `Here's your cart:`;

	let shopifyData = JSON.parse(props.data.displayResponse);
	let cartCollections = shopifyData.data.data.cart;
	let cartId = shopifyData.data.data.cart;

	const productPrice = (price: any, currencyCode) => {
		return currencyCode == 'USD'
			? '$' +
					Number(price)
						.toFixed(2)
						.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
			: '₹' +
					Number(price)
						.toFixed(2)
						.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};

	const orderProducts = (showButton: any, cart?, node?) => {
		if (showButton.indexOf('Checkout') > -1) {
			props.addUserResponse('Checkout', Date.now());
			props.makePayment();
			///props.handleSubmit(cartId.id.toString(), {}, { isHidden: true });
		} else if (showButton.indexOf('Remove') > -1) {
			let removeId = `${cartId.id}$$@$$${cartId.lines.edges[0].node.id}`;
			props.addUserResponse('Remove', Date.now());
			props.addServerMessage('Item removed from cart', `${node}$$@$$${cart}`);
		} else if (showButton.indexOf('Modify') > -1) {
			props.addUserResponse('Modify', Date.now());
			props.addServerMessage(
				'Please enter the quantity',
				`${node}$$@$$${cart}`
			);
		} else {
			props.addUserResponse('Continue Shopping', Date.now());
			props.addServerMessage(
				"I'm happy to help you continue shopping! Can you please provide me with more information on what you are looking for?"
			);
		}
	};
	const returnCount = () => {
		let totalCount = 0;
		cartCollections.lines.edges.map((item) => {
			totalCount = totalCount + item.node.quantity;
		});
		return totalCount;
	};
	const returnPrice = () => {
		return productPrice(
			cartCollections.cost.totalAmount.amount,
			cartCollections.cost.totalAmount.currencyCode
		);
	};
	let storeProducts = [];
	const getFormatData = (data: any) => {
		data.lines.edges.map((product: any) => {
			let productSize = product.node.merchandise.title.split(' / ')[0]
				? `Size: ${product.node.merchandise.title.split(' / ')[0]} `
				: '';
			let productColor = product.node.merchandise.title.split(' / ')[1]
				? `| Colour: ${product.node.merchandise.title.split(' / ')[1]} `
				: '';
			let productStorage = product.node.merchandise.title.split(' / ')[2]
				? `| Storage: ${product.node.merchandise.title.split(' / ')[2]} `
				: '';
			let productAmount = productPrice(
				cartCollections.cost.totalAmount.amount / product.node.quantity,
				cartCollections.cost.totalAmount.currencyCode
			);
			let singleProduct = {
				resourceURL: product.node.merchandise.product.images.edges[0].node.src,
				title: product.node.merchandise.product.title,
				description: `${productSize}${productColor}${productStorage}| Quantity: ${product.node.quantity}`,
				price: productPrice(
					cartCollections.cost.totalAmount.amount,
					cartCollections.cost.totalAmount.currencyCode
				),
				cardIndex: indexedDB.toString(),
				cartId: cartId,
				cartCount: cartCollections.lines.edges.length,
			};
			storeProducts.push(singleProduct);
		});

		return storeProducts;
	};

	return (
		<ShopifyCart
			{...{ background: background, foreground: foreground }}
			className={`ff-shopify-view-cart-container  ${
				props.shouldDisableActions ? 'ff-disable-card' : ''
			}`}
		>
			<div className='ff-shopify-view-cart-header'>
				<div className='ff-shopify-cart-total'>
					<span className='body-text-1'>Cart total</span>
					<span className='button-text-1'>{returnPrice()}</span>
				</div>
				<div className='ff-shopify-cart-items'>
					<span className='body-text-1'>Items in cart</span>
					<span className='button-text-1'>{returnCount()}</span>
				</div>
			</div>
			{cartCollections.lines.edges.length > 0 ? (
				<div className='ff-shopify-view-cart-products'>
					{getFormatData(cartCollections).map((e: any) => {
						return (
							<span className='ff-shopify-single-cart'>
								<div className='ff-shopify-cart-description'>
									<div className='ff-shopify-cart-image'>
										<img
											src={e.resourceURL}
											alt='image'
											className='cart-image-icon'
										/>
									</div>
									<div className='ff-shopify-cart-details'>
										<span className='button-text-2'>{e.title}</span>
										<span className='caption-text'>{e.description}</span>
									</div>
								</div>
								<div className='ff-shopify-cart-buttons'>
									{cartButtons.map((showButton, i) => {
										return (
											<Button
												key={i}
												label={showButton}
												size={'normal'}
												fullWidth={true}
												variant={'outline'}
												className='cart-buttons-confirm'
												onClick={() =>
													orderProducts(
														showButton,
														e.cartId.id,
														e.cartId.lines.edges[0].node.id
													)
												}
											/>
										);
									})}
								</div>
							</span>
						);
					})}
				</div>
			) : null}
			<div className='ff-shopify-view-cart-footer'>
				{postCartButtons.map((showButton, i) => {
					return (
						<Button
							key={i}
							label={showButton}
							size={'normal'}
							fullWidth={true}
							variant={'filled'}
							className='cart-buttons-confirm'
							onClick={() => orderProducts(showButton)}
						/>
					);
				})}
			</div>
		</ShopifyCart>
	);
};
